import React, { useState, useEffect } from "react";
import queryString from 'query-string';
import _ from 'lodash';
import './style.scss';
import { EditOutlined, DeleteOutlined, CloseOutlined } from "@ant-design/icons";
import { blue, red } from '@ant-design/colors';
import { Layout, Space, Button, Table, Popconfirm, PageHeader } from 'antd';
import R2Footer from "../../components/Footer";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MenuCustomizeService from "../../services/MenuCustomizeService";
import { useSelector } from 'react-redux';
import NewCustomization from "../NewCustomization";
import Delete from "../../assets/images/delete_icon.svg";
import Edit from "../../assets/images/edit_icon.svg";


const { Content } = Layout;
const newCustom = {
    "name": "",
    "menu_id": null,
    "menu_group_id": null,
    "menu_customization_menu_items": [],
    "menu_customization_exceptions": [],
    'menu_customization_addons':[],
    "menu_customization_preferences": [
        {
            "label": "",
            "num_selectable_options": 1,
            "has_added_cost": false,
            "options": '[]',
            // 'menu_customization_addons':[]
        }
    ]
}


const MenuCustomize = (props) => {
    const parsed = queryString.parse(window.location.search);
    const [addNew, setAddNew] = useState(false);
    const [loading, setLoading] = useState(false);
    const [dataList, setDataList] = useState({});

    const adminRestaurant = useSelector((state) => state.admin)
    const getCustomizationList = async() => {
        const res = await MenuCustomizeService.getCustomizationList();
        setDataList(res);
    }
    useEffect(()=>{
        if(parsed.menu){
            const customDataFill = _.cloneDeep(newCustom)
            customDataFill.menu_id = parseInt(parsed.menu);
            customDataFill.menu_group_id = parseInt(parsed.group);;
            customDataFill.menu_customization_menu_items=[{menu_item_id:parseInt(parsed.item)}]
            setAddNew(customDataFill);
        }
        getCustomizationList();
    },[]);
    const onUpdateClick = (record) => {
        let selRecord = {...record};
        // selRecord.menu_customization_items = record.menu_customization_items
        // .map((mItem)=>({menu_item_id: mItem.menu_item_id}));
        // selRecord.menu_customization_exceptions = record.menu_customization_exceptions
        // .map((mItem)=>({menu_item_id: mItem.menu_item_id}));
        // selRecord.menu_customization_preferences = record.menu_customization_preferences
        // .map((mItem)=>(mItem.has_added_cost ? {...mItem, id: undefined }
        //  : {...mItem, id: undefined}));
        // selRecord.menu_customization_addons = record.menu_customization_addons
        //  .map((mItem)=>({option_name: mItem.option_name, cost: mItem.cost}));
        setAddNew(selRecord);
    };
    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '25%' 
        },
        {
            title: 'Applicable on',
            dataIndex: 'applicable',
            key: 'applicable',
            width: '60%', 
            render: (_, record) => {
                return <div className="applicable_list">
                        {record?.menu_customization_menu_items?.map((item)=>{
                             return <div className="chip-view">{item?.menu_item?.name}</div>
                        })}
                    {record?.menu_customization_exceptions?.map((item)=>{
                        return <div className="chip-view bg-red">{item?.menu_item?.name}</div>
                    })}
                </div>
            }
        },
        {
            title: 'Action',
            width: '15%', 
            render: (_, record) => {
                return <div
                    style={{
                        display: "flex", width: '150px'}}>
                        <>
                            <img src={Edit} alt="" className="update_action" onClick={(e) => {
                                e.stopPropagation()
                                onUpdateClick(record);
                            }} /> &nbsp;&nbsp;
                            <Popconfirm title="Sure to delete?" onConfirm={(e) => {
                                e.stopPropagation()
                                deleteCode(record.id)
                            }
                            }>
                            <img src={Delete} alt="" className="update_action" />
                            </Popconfirm>
                        </>
                </div>
            }
        }
    ];

    const deleteCode = async (id) => {
        await MenuCustomizeService.deleteCustomization(id);
        getCustomizationList();
    };

if(addNew){
    return <Layout className="u-page-layout">
        <NewCustomization 
        setAddNew={setAddNew} 
        adminRestaurant={adminRestaurant} 
        addNew={addNew} 
        getCustomizationList={getCustomizationList}
        newCustom={_.cloneDeep(newCustom)} />
    </Layout>
}
    return (
        <Layout className="u-page-layout">
            <Content
                className="page-padding"
            >
                <Space direction="vertical" style={{ width: "100%" }}>
                    <PageHeader
                    className="page-header"
                        title="Menu Customization"
                        extra={[
                            <Button type="primary" 
                            onClick={() => { setAddNew(_.cloneDeep(newCustom)); }}>Create Customization</Button>,
                        ]} />
                        <div className="table_section">
                            <div className="table-name">
                                <h2 className="heading">Existing Customization</h2>
                                <div className="application_type">
                                    <div className="include"><div/>Included</div>
                                    <div className="exclude"><div/>Excluded</div>
                                </div>
                            </div>
                            <Table columns={columns} bordered dataSource={dataList?.menu_customizations || []} className="customise-table" />
                        </div>
                </Space>
            </Content>
            <R2Footer />
        </Layout>
    )
}

const mapStateToProps = state => {
    return {
        adminRestaurant: state.admin,
    };
};
export default withRouter(connect(
    mapStateToProps
)(MenuCustomize));
